import { StripeNoticeModal } from "./StripeNoticeModal";
import { show } from "@ebay/nice-modal-react";

/**
 * Display a modal with a list of updates that need to be made in Stripe's settings, and a link to update.
 * @param stripeErrorReasons The field errors in readable format.
 * @returns Promise representing dialog lifetime.
 */
export async function showStripeNoticeModal(stripeErrorReasons: string[]) {
    return await show(StripeNoticeModal, { stripeErrorReasons });
}
